import { classNames } from "@ember-decorators/component";
import avatar from "discourse/helpers/avatar";
import formatUsername from "discourse/helpers/format-username";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const UserRow = dt7948.c(class UserRow extends SelectKitRowComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    {{avatar this.item imageSize=\"tiny\"}}\n\n    <span class=\"username\">{{formatUsername this.item.username}}</span>\n\n    {{#if this.item.name}}\n      <span class=\"name\">{{this.item.name}}</span>\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        avatar,
        formatUsername
      })
    }), this);
  }
}, [classNames("user-row")]);
export default UserRow;